<template>
    <div class="sidebar"
       :data="backgroundColor">

        <div class="sidebar-wrapper">

            <div class="logo pb-2">
                <router-link to="/xlrs/home" class="simple-text logo-normal">
                    {{ $auth.owner ? $auth.owner.name : '' }}
                </router-link>
            </div>

            <slot></slot>

            <ul class="nav">
                <slot name="links">
                    <sidebar-item
                        v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link"
                    >
                        <sidebar-item
                            v-for="(subLink, index) in link.children"
                            :key="subLink.name + index"
                            :link="subLink"
                        >
                        </sidebar-item>
                    </sidebar-item>
                </slot>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            backgroundColor: {
                type: String,
                default: "green"
            },

            sidebarLinks: {
                type: Array,
                default: () => []
            },

            autoClose: {
                type: Boolean,
                default: true
            }
        },

        provide() {
            return {
                autoClose: this.autoClose
            };
        },

        beforeDestroy() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.showSidebar = false;
            }
        }
    }
</script>

<style scoped>

    .simple-text {
        font-size: 16px !important;
    }

</style>
<style>

    @media (min-width: 992px) {
        .navbar-search-form-mobile,
        .nav-mobile-menu {
            display: none;
        }
    }

</style>
